// Autogenerated file
export const billingNotificationTypesEnum = {
    NewInvoice: "NewInvoice",
    SubscriptionExpires: "SubscriptionExpires",
    InvoiceExpired: "InvoiceExpired",
};
export const billingNotificationTypes = [
    { label: "Новый счёт", value: "NewInvoice" },
    { label: "Подписка заканчивается через 3 дня", value: "SubscriptionExpires" },
    { label: "Просрочка оплаты", value: "InvoiceExpired" },
];
